import classNames from 'classnames/bind';
import styles from './Copyright.module.css';
import {
  COPYRIGHT_LAW_COMPLIANCE,
  INFRINGEMENT_REMOVAL_NOTICE,
  LICENSED_MATERIALS_NOTICE,
  REFER_TO_TERMS_OF_SERVICE,
} from '../../../../constants';
import parse from 'html-react-parser';

export default function Copyright() {
  const cx = classNames.bind(styles);

  return (
    <div>
      <p className={cx('paragraph')}>
        {COPYRIGHT_LAW_COMPLIANCE} {INFRINGEMENT_REMOVAL_NOTICE}
      </p>
      <p className={cx('paragraph')}>
        {LICENSED_MATERIALS_NOTICE} {parse(REFER_TO_TERMS_OF_SERVICE)}
      </p>
    </div>
  );
}
